module.exports = __webpack_public_path__ + "16420f31eed8cb34aec906f7947f94bf.svg";